import { render, staticRenderFns } from "./MissionDetailLogBook.vue?vue&type=template&id=638589d5&scoped=true"
import script from "./MissionDetailLogBook.vue?vue&type=script&lang=ts"
export * from "./MissionDetailLogBook.vue?vue&type=script&lang=ts"
import style0 from "./MissionDetailLogBook.vue?vue&type=style&index=0&id=638589d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638589d5",
  null
  
)

export default component.exports